import { useState, useEffect } from 'react';
import { api, PanelHowTo } from './_barrel.js';

                function LinkedBusinessesPanel({ token, subjectId, setView, setSelectedBusiness }) {
            const [items, setItems] = useState(null);
            const [error, setError] = useState(null);
            const [open, setOpen] = useState(false);  // record opens compact

            useEffect(() => {
                (async () => {
                    try {
                        const r = await api(`/api/v1/subjects/${subjectId}/linked-businesses`, {}, token);
                        setItems(r || []);
                    } catch (e) { setError(e.message); }
                })();
            }, [token, subjectId]);

            if (error) return null;  // silent — this panel is supplementary
            if (items === null) return null;
            if (items.length === 0) return null;  // hide when empty

            const bandColour = b => b === 'critical' ? 'var(--red)' :
                                    b === 'high'     ? 'var(--amber)' :
                                    b === 'moderate' ? 'var(--gold)' :
                                    'var(--green)';

            return (
                <div className="panel mb-6">
                    <div className="panel-header is-self-collapse flex justify-between items-center cursor-pointer" onClick={() => setOpen(!open)}>
                        <div>
                            <div className="font-display text-xl gold">Linked Businesses ({items.length})</div>
                            <div className="text-xs font-mono text-muted">
                                Companies this subject is on record with
                            </div>
                        </div>
                        <div className="text-xs text-muted">{open ? '▾' : '▸'}</div>
                    </div>
                    <PanelHowTo id="linked_businesses" />
                    {open && items.map(b => (
                        <div key={b.business_id}
                             className="table-row px-6 py-3 cursor-pointer"
                             onClick={() => { setSelectedBusiness?.(b.business_id); setView('business-detail'); }}>
                            <div className="flex justify-between items-start gap-4">
                                <div className="flex-1 min-w-0">
                                    <div className="font-display text-base gold">
                                        {b.display_name || b.legal_name}
                                    </div>
                                    <div className="text-xs text-muted font-mono mt-1">
                                        {b.link_type.replace(/_/g, ' ')}
                                        {b.company_number && ` · ${b.company_number}`}
                                        {b.company_status && ` · ${b.company_status}`}
                                        {!b.is_current && ' · former'}
                                    </div>
                                </div>
                                <div className="flex items-center gap-3" style={{minWidth: '220px', justifyContent: 'flex-end'}}>
                                    {b.hostile_mentions_active > 0 && (
                                        <span className="severity-pill band-moderate">
                                            {b.hostile_mentions_active} active hostile mention(s)
                                        </span>
                                    )}
                                    {b.risk_band && (
                                        <span className="font-mono text-xs uppercase tracking-widest" style={{color: bandColour(b.risk_band)}}>
                                            {b.risk_band} · {b.composite_score?.toFixed(1)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }

export { LinkedBusinessesPanel };
